import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Link,
  Stack,
  Typography,
} from '@mui/material'
import { grey } from '@mui/material/colors'
import JJConnectLogo from 'assets/jjConnectLogo.svg'
import { DeployVersion } from 'components/DeployVersion'
import { EULADialog } from 'pages/Login/CreateAccount/EULADialog'
import { useState } from 'react'

export const AboutModal = ({
  isModalOpen,
  toggleIsOpen,
  toggleModalIsOpen,
}: {
  isModalOpen: boolean
  toggleModalIsOpen: () => void
  toggleIsOpen: () => void
}) => {
  const [isEULAModalOpen, setIsEULAModalOpen] = useState(false)
  const toggleEULAModalIsOpen = () => {
    setIsEULAModalOpen(!isEULAModalOpen)
  }

  return (
    <>
      <Dialog
        open={isModalOpen}
        maxWidth={'xl'}
        fullWidth
        PaperProps={{ sx: { p: 0, maxWidth: '900px' } }}
        onClose={toggleIsOpen}
      >
        <DialogTitle bgcolor={grey[50]} sx={{ p: 0 }} className="border-b">
          <Box px={4} py={4}>
            <img src={JJConnectLogo} alt="JJ Connect logo" />
          </Box>
        </DialogTitle>

        <DialogContent sx={{ pt: 4, px: 4 }}>
          <Box paddingBottom={2} paddingTop={3}>
            <Link
              sx={{ cursor: 'pointer' }}
              onClick={() => toggleEULAModalIsOpen()}
            >
              End User License Agreement (EULA)
            </Link>
          </Box>
        </DialogContent>

        <DialogActions
          sx={{ borderTop: `1px solid ${grey[300]}`, pt: 2, pb: 2, px: 4 }}
        >
          <Stack direction="column" gap={1} flexGrow={1}>
            <Stack direction="column">
              <DeployVersion />
            </Stack>
            <Stack direction="column">
              <Typography className="text-secondary">{`Copyright \u00A9 ${new Date().getFullYear()}`}</Typography>
            </Stack>
          </Stack>

          <Button onClick={toggleModalIsOpen}>Cancel</Button>
        </DialogActions>
      </Dialog>
      <EULADialog
        showEULAUpdatedLabel={false}
        showAcceptButton={false}
        showCancelButton={true}
        isModalOpen={isEULAModalOpen}
        onConfirm={() => {}}
        onClose={() => toggleEULAModalIsOpen()}
      ></EULADialog>
    </>
  )
}
